import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ownerSelector } from "../../store/store";
import { isAiPosterAllowedForEmail } from "../../utils/aiContent";

/** Blocks /ai-content routes for users outside the AI Poster allowlist. */
const RequireAiPosterAccess = ({ children }: { children: ReactElement }) => {
  const { currentUser } = useSelector(ownerSelector);
  if (!isAiPosterAllowedForEmail(currentUser?.email)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RequireAiPosterAccess;
